import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { WorkAPI } from "../../../axios/api";
import {
  useAbortedEffect,
  useSearch,
  useTable,
} from "../../../components/hooks";
import useExcel from "../../member/record/useExcel";
import moment from "moment";

import ModuleTitle from "../../../components/common/title";
import { setPageSetting } from "../../../service/common";
import { system_table, system_dropdown } from "../../../service/system";
import { option_category, option_category_obj } from "../../../service/option";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";

export default function MemberRecordExecutionRate({ memberData = [] }) {
  const route_params = useParams();
  const dispatch = useDispatch();
  const [reload, setReload] = useState({ list: false });
  const {
    setTbData,
    tbTotalRecords,
    setTbTotalRecords,
    setTbFirstIndex,
    setTbRows,
    tbColumns,
    setTbColumns,
    renderTable,
    setPageAction,
  } = useTable();
  // 篩選條件
  const defaultFilter = {
      memberid: memberData?.length > 0 ? memberData[0].id : null,
      searchDate: new Date(),
    },
    pagePath = "/record/execution";
  const {
    filterData,
    setFilterData,
    search,
    setSearch,
    changeFilter,
    renderSearchWrap,
  } = useSearch({
    defaultFilter,
    pagePath: [pagePath],
    tbSetting: { setTbFirstIndex, setTbRows },
    reloadAction: () => setReload((state) => ({ ...state, list: true })),
  });
  const { exportExcel } = useExcel();

  useEffect(() => {
    const action = ({ startIndex, rows }) => {
      let temp = {
        ...search,
        page: Math.floor(startIndex / rows) + 1,
        size: rows,
      };
      setFilterData(temp);
      setSearch(temp);
    };
    setPageAction(
      () =>
        ({ startIndex, rows }) =>
          action({ startIndex, rows })
    );
  }, [search]);

  // 取得列表資料
  useAbortedEffect(
    (signal) => {
      if (!reload.list || !search.memberid || !search.searchDate) return;

      setPageSetting({ params: search, page: pagePath });

      getData({ signal, type: "list" });
    },
    [reload]
  );

  const getData = async ({ signal, type, page = search.page } = {}) => {
    dispatch(setProgress(true));

    let params = {
      ...search,
      size: 10,
      // searchDate: search.searchDate
      //   ? moment(search.searchDate).format("YYYY-MM-DD")
      //   : null,
      startDate: search.searchDate
        ? moment(search.searchDate).format("YYYY-MM-DD")
        : null,
      endDate: search.searchDate
        ? moment(search.searchDate).format("YYYY-MM-DD")
        : null,
    };

    // let result_goal = await WorkAPI.getPersonalGoalsDatasByMemberid({
    //   data: {
    //     memberid: search.memberid,
    //   },
    //   options: { signal },
    // });

    // console.log(result_goal);

    WorkAPI.getDoRateListByMemberid({
      data: params,
      options: { signal },
    }).then((result) => {
      let { Response, data, message } = result;

      if (Response === 1) {
        if (data.length > 0) data = data[0];
        console.log(result);

        let dayIndex = new Date(params.startDate).getDay();
        if (dayIndex === 0) dayIndex = 7;

        let formatData = {
          member_name: memberData.find((item) => item.id === search.memberid)
            ?.name,
          date: params.startDate,
          execution_finish_count: 0, // 已執行個數
          execution_total_count: 0, // 需執行個數
        };
        option_category.record.forEach((item) => {
          formatData[`type${item.type}`] =
            data?.today_record?.[`record_${item.apiKey}`] === 1
              ? 2
              : data?.data?.[`type${item.type}`]?.[`day${dayIndex}`] ?? "-";
          if (formatData[`type${item.type}`] === 2)
            formatData.execution_finish_count++;
          if ([1, 2].includes(formatData[`type${item.type}`]))
            formatData.execution_total_count++;
        });
        formatData.execution_rate = formatData.execution_total_count
          ? Math.round(
              (formatData.execution_finish_count /
                formatData.execution_total_count) *
                10000
            ) / 100
          : 0;

        if (type === "excel") {
          checkExport({ data: [formatData] });
        } else {
          setTbData([formatData]);
          setTbTotalRecords(1);
          setReload((state) => ({
            ...state,
            list: false,
          }));
        }
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: message,
            detail: "",
          })
        );
      }

      dispatch(setProgress(false));
    });
  };

  useEffect(() => {
    setTbColumns([
      {
        key: "member_name",
        field: "member_name",
        header: "姓名",
        className: "flex-grow-1 w-5rem",
        exportOptions: {
          width: 15,
        },
      },
      {
        key: "date",
        field: "date",
        header: "日期",
        className: "flex-grow-1 w-5rem",
        isDate: true,
        exportOptions: {
          width: 15,
        },
      },
      ...option_category.record.map((item) => ({
        key: `type${item.type}`,
        field: `type${item.type}`,
        header: item.label,
        className: "flex-grow-1 w-5rem",
        body: (data) => (
          <>
            <span
              className={classNames({
                "text-red-400": data[`type${item.type}`] === 1,
                "text-green-400": data[`type${item.type}`] === 2,
              })}
            >
              {data[`type${item.type}`] === 2
                ? "V"
                : data[`type${item.type}`] === 1
                ? "X"
                : "-"}
            </span>
          </>
        ),
        exportOptions: {
          width: 15,
          align_h: "center",
          bodyColStyles: ({ allData }) => {
            return {
              font_color:
                allData[`type${item.type}`] === 2
                  ? "459e74"
                  : allData[`type${item.type}`] === 1
                  ? "e35b68"
                  : "000000",
            };
          },
          formatVal: ({ allData }) => {
            return allData[`type${item.type}`] === 2
              ? "V"
              : allData[`type${item.type}`] === 1
              ? "X"
              : "-";
          },
        },
      })),
      {
        key: "execution_rate",
        field: "execution_rate",
        header: "執行率",
        className: "flex-grow-1 w-5rem",
        body: (data) => <>{`${data.execution_rate}%`}</>,
        isPercent: true,
        exportOptions: {
          width: 15,
        },
      },
    ]);
  }, [pagePath]);

  const checkExport = ({ data }) => {
    if (data && data.length > 0) {
      exportExcel({
        fileName: `${option_category_obj.record.health.label}`,
        headColumns: tbColumns.filter((item) => !item.exportOptions.isSkip),
        data,
      });
    } else {
      dispatch(
        setToast({
          severity: "warn",
          summary: "無資料",
          detail: "",
        })
      );
    }
  };

  return (
    <>
      {renderSearchWrap({
        isShow: false,
        template: (
          <>
            <div className="col-12 sm:col-6 md:col-4 xl:col-2 flex align-items-start flex-column mt-2 md:mt-0">
              <label
                htmlFor="username"
                className="w-4rem white-space-nowrap text-left mb-1"
              >
                會員姓名
              </label>
              <Dropdown
                name="memberid"
                className="w-full"
                value={filterData.memberid}
                onChange={(e) => changeFilter(e)}
                options={memberData}
                optionLabel="name"
                optionValue="id"
                emptyMessage={system_dropdown.empty}
                filter={true}
                filterBy="name"
                emptyFilterMessage={system_dropdown.emptyFilter}
                showClear={false}
              />
            </div>

            <div
              className={classNames(
                "col-12 sm:col-6 md:col-4 xl:col-2 flex align-items-start flex-column mt-2 md:mt-0"
              )}
            >
              <label
                htmlFor="username"
                className="w-4rem white-space-nowrap text-left mb-1"
              >
                日期
              </label>
              <Calendar
                className="w-full"
                name="searchDate"
                value={filterData.searchDate}
                onChange={(e) => changeFilter(e)}
                readOnlyInput
              />
            </div>
            <div
              className={classNames(
                "col-12 md:col-4 xl:col-8 flex align-items-end mt-2"
              )}
            >
              <Button
                className={classNames(
                  "ml-auto md:ml-0 p-button-info p-button-sm w-auto px-3"
                )}
                type="button"
                icon="pi pi-search"
                label="查詢"
                onClick={() => {
                  setSearch({
                    ...filterData,
                    page: 1,
                  });
                  setTbFirstIndex(0);
                }}
              />

              <Button
                className="p-button-secondary p-button-sm w-auto ml-2 md:ml-auto px-3"
                type="button"
                label="匯出"
                onClick={() => getData({ type: "excel", page: -1 })}
              />
            </div>
          </>
        ),
      })}

      {renderTable({
        className: "mt-2",
        options: {
          scrollable: true,
          scrollDirection: "both",
        },
      })}
    </>
  );
}
